import { render } from "./BridgingVolunteerPage.vue?vue&type=template&id=3cc731e2"
import script from "./BridgingVolunteerPage.vue?vue&type=script&lang=js"
export * from "./BridgingVolunteerPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__